module.exports = __webpack_public_path__ + "img/useravatar@2x.0fcbc409.png";